export const types = {
  'MODAL_CLOSE': 'closeModal',
  'MODAL_OPEN': 'openModal',
  'MODAL_SET_DATA': 'setModalData'
};
